var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Faq',{attrs:{"faq":_vm.faq,"buttonLoading":_vm.buttonLoading},on:{"saveFaq":_vm.saveFaq}})
}
var staticRenderFns = []

export { render, staticRenderFns }